<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.3312 0L14.5732 1.81417L7.49045 8.8189L5.42675 6.85354L3.59236 5.03937L0 8.59213L1.8344 10.4063L5.65605 14.1858L7.41401 16L9.24841 14.1858L18.1656 5.36693L20 3.55276L16.3312 0Z" />
</svg>
